import React from 'react'
import { useMessaging, formatTimeDiff } from './MessagingProvider'
import { useQuery } from '@tanstack/react-query'
import { apiGet } from '~/util/api'
import { cn } from '~/lib/utils'
import useTranslation from '../shared/TranslationProvider'

const ThreadList = () => {
  const { t } = useTranslation('CoachMessageThread')
  const { location } = useMessaging()
  const { error, data: messageThreads } = useQuery({
    queryKey: ['messageThreads', location.pathname],
    queryFn: () => apiGet(`${location.pathname}.json`).then((res) => res.data),
    refetchInterval: 10000,
  })

  if (error) return t('reply') + error.message

  return (
    <div className="flex flex-col gap-2 p-4 pt-0">
      {messageThreads?.length === 0 && (
        <div className="flex h-full text-center text-sm">
          {t('received_messages_appear_here')}
        </div>
      )}
      {messageThreads?.map((thread) => (
        <ThreadButton key={thread.id} thread={thread} />
      ))}
    </div>
  )
}
export default ThreadList

const ThreadButton = ({ thread }) => {
  const { t } = useTranslation('CoachMessageThread')
  const { currentThreadId, userIsCoach } = useMessaging()
  const {
    id: threadId,
    subject,
    last_message_created_at: lastMessageSentAt,
    last_message_preview: lastMessagePreview,
    coach_read: coachRead,
    candidate_read: candidateRead,
    candidate_name: candidateName,
    coach_name: coachName,
  } = thread
  const isSelected = threadId === currentThreadId
  const otherUserName = userIsCoach ? candidateName : coachName
  const isRead = userIsCoach ? coachRead : candidateRead

  return (
    <a
      className={cn(
        'flex flex-col items-start gap-2 rounded-3xl border border-silver px-6 py-4 text-left text-sm text-intoo-text transition-all hover:bg-willow-brook hover:text-intoo-text focus:text-intoo-text',
        isSelected &&
          'bg-intoo-green-coachcta text-white hover:bg-intoo-green-coachcta-hover hover:text-white focus:text-white',
      )}
      href={`#${threadId}`}
    >
      <div className="flex w-full flex-col gap-1">
        <div className="flex items-center">
          <div className="flex items-center gap-2">
            <div className="text-lg font-semibold">
              {t('from')}: {otherUserName}
            </div>
            {!isRead && (
              <span className="flex h-2 w-2 rounded-full bg-intoo-green-coachcta" />
            )}
          </div>
          <div className="ml-auto text-xs">
            {formatTimeDiff(lastMessageSentAt)}
          </div>
        </div>
        <div className="text-xs font-medium">
          {t('subject')}: {subject}
        </div>
      </div>
      <div className="line-clamp-2 text-xs">{lastMessagePreview}</div>
    </a>
  )
}
